// THIS FILE IS GENERATED. ANY CHANGES TO THIS FILE WILL BE LOST.
import type { TOC } from '@ember/component/template-only';

export interface ReplyIconSignature {
  Element: SVGSVGElement;
}

export const ReplyIcon: TOC<ReplyIconSignature> = <template><svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" ...attributes>
<path d="M13 10H8.414L10.707 7.707L9.293 6.293L4.586 11L9.293 15.707L10.707 14.293L8.414 12H13C15.205 12 17 13.794 17 16V18H19V16C19 12.691 16.309 10 13 10Z"/>
</svg>
</template>;